import { cn } from 'utils/styles';
import Button from 'components/shared/Buttons/BaseButton';

interface CalculatorActionsProps {
  /** Omitted by a calculator with nothing to clear, which then renders Calculate alone. */
  onReset?: () => void;
  className?: string;
}

/**
 * The Calculate/Reset pair every calculator form ends on. Reset is a bare button rather than a
 * second `Button`, so the primary action is the only thing that reads as one.
 */
export const CalculatorActions = ({ onReset, className }: CalculatorActionsProps) => (
  <div className={cn('flex flex-col items-center gap-4 sm:flex-row', className)}>
    <Button type="submit" className="w-full sm:w-auto">
      Calculate
    </Button>
    {onReset && (
      <button type="button" className="cursor-pointer text-body-saans" onClick={onReset}>
        Reset
      </button>
    )}
  </div>
);
